import React from 'react';
import { StyleSheet, View } from 'react-native';
import RNTooltip from 'react-native-walkthrough-tooltip';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Spacer from '../spacer';
import Text from '../text';
import Colors from '../colors';
const Vertical = ['top', 'bottom'];
const Horizontal = ['left', 'right', 'middle'];
const StyledText = styled(Text.BodyExtraSmall)`
  line-height: 15.6px;
`;
export default function Tooltip(props) {
  const placement = Vertical.includes(props.verticalPlacement) ? props.verticalPlacement : Tooltip.defaultProps.verticalPlacement;
  const arrows = {
    left: {
      position: 'absolute',
      left: 16
    },
    right: {
      position: 'absolute',
      left: 'auto',
      right: 16
    }
  };
  const width = {
    content: {
      maxWidth: props.contentMaxWidth
    },
    text: {
      width: props.textWidth
    }
  };
  return /*#__PURE__*/React.createElement(RNTooltip, {
    isVisible: props.visible,
    backgroundColor: Colors.transparent,
    placement: placement,
    arrowSize: {
      width: 20,
      height: 14
    },
    disableShadow: true,
    showChildInTooltip: props.showChildInTooltip,
    contentStyle: [styles.contentContainer, width.content, props.renderIcon ? styles.regularPadding : styles.smallPadding],
    content: /*#__PURE__*/React.createElement(React.Fragment, null, props.renderIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
      style: styles.iconTile
    }, props.renderIcon()), /*#__PURE__*/React.createElement(Spacer, {
      size: "f8",
      width: true
    })), /*#__PURE__*/React.createElement(View, {
      style: [styles.textContainer, width.text, !props.renderIcon && styles.noIconContent]
    }, props.title !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
      style: styles.title
    }, props.title), /*#__PURE__*/React.createElement(Spacer, {
      size: "f4",
      width: true
    })), /*#__PURE__*/React.createElement(StyledText, {
      style: !props.renderIcon && styles.noIconText,
      color: props.textColor
    }, props.content))),
    onClose: props.onClose,
    arrowStyle: arrows[props.horizontalPlacement]
  }, props.children);
}
Tooltip.propTypes = {
  visible: PropTypes.bool,
  verticalPlacement: PropTypes.oneOf(Vertical),
  horizontalPlacement: PropTypes.oneOf(Horizontal),
  textColor: PropTypes.string,
  onClose: PropTypes.func,
  content: PropTypes.string,
  children: PropTypes.object,
  renderIcon: PropTypes.func,
  showChildInTooltip: PropTypes.bool,
  title: PropTypes.string,
  contentMaxWidth: PropTypes.number,
  textWidth: PropTypes.number
};
Tooltip.defaultProps = {
  visible: false,
  verticalPlacement: 'bottom',
  horizontalPlacement: 'middle',
  textColor: Colors.white,
  onClose: () => {},
  content: '',
  children: null,
  renderIcon: null,
  showChildInTooltip: true,
  title: '',
  contentMaxWidth: 200,
  textWidth: 136
};
const styles = StyleSheet.create({
  contentContainer: {
    backgroundColor: Colors.gray500,
    flex: 1,
    flexDirection: 'row'
  },
  regularPadding: {
    padding: 16
  },
  smallPadding: {
    padding: 12
  },
  noIconContent: {
    width: 176
  },
  noIconText: {
    alignItems: 'center',
    textAlign: 'center',
    lineHeight: 15.6
  },
  iconTile: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  textContainer: {
    justifyContent: 'center',
    lineHeight: 15.6,
    flexDirection: 'column'
  },
  title: {
    fontFamily: 'LarsseitBold',
    fontSize: 12,
    color: Colors.white,
    textAlign: 'left',
    lineHeight: 26
  }
});
//# sourceMappingURL=index.js.map